// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2290) return "static/chunks/2290-9ee5fc32a713db15.js";
	if (chunkId === 1316) return "static/chunks/1316-8b0c43e594670ca3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3811":"115bf0840ae9f706","3987":"dbc21575ad6c529c","8077":"f19b4ce92ee5edaf"}[chunkId] + ".js";
};